import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-create-url-card',
  templateUrl: './create-url-card.component.html',
  styleUrls: ['./create-url-card.component.scss']
})
export class CreateUrlCardComponent implements OnInit {
  fileImg64: any;
  wrongSize: any;
  cardForm: FormGroup;
  srcData: SafeResourceUrl;

  // urlExist = false;
  maxLength = 150;

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private utilService: UtilService
  ) {
  }

  ngOnInit(): void {
    this.createForm();
  }


  sendData(): any {
    const dataToSend = {
      ...this.cardForm.value,
    };

    this.activeModal.close(dataToSend);
  }

  private createForm(): any {
    this.cardForm = this.fb.group({
      title: ['', Validators.required],
      order: [null, Validators.required],
      img: ['', Validators.required],
      img64: ['', Validators.required],
      subTitle: ['', Validators.required],
      codeImg: [1],
      activeButton: [0],
      nameButton: [''],
      url: [''],
    });
  }

  getBase64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        if (image.width <= 200 && image.height <= 150) {
          this.wrongSize = null;
          this.fileImg64 = image.src;
          this.cardForm.get('img').setValue((event.target.files[0]).name);
          this.cardForm.get('img64').setValue(this.fileImg64.split(',')[1]);
          this.srcData = this.utilService.getSanitizer(image.src);
        } else {
          this.wrongSize = 'Resolución de imagen no permitida (requerida: 200px x 150px)';
          return false;
        }
      };
    };
    reader.onerror = (error) => {
    };
  }

  resetWizzards(all: boolean) {
    if (all === true) {
      this.cardForm.get('url').setValue('');
      this.cardForm.get('activeButton').setValue(0);
      this.cardForm.get('nameButton').setValue('');
    } else if (all === false) {
      this.cardForm.get('nameButton').setValue('');
    }
  }

  hasURLChange(val: string) {
    const urlControl = this.cardForm.get('url');
    val === 'yes' ? urlControl.setValidators([Validators.required]) : urlControl.clearValidators();
    urlControl.updateValueAndValidity();
  }

  hasButtonTypeChange(val: string) {
    const nameButtonControl = this.cardForm.get('nameButton');
    val.toString() === '1' ? nameButtonControl.setValidators([Validators.required]) : nameButtonControl.clearValidators();
    nameButtonControl.updateValueAndValidity();
  }
}
